import forge from 'node-forge';

let fnResponseSuccess = function (response) {
    let headers = response.headers;

    if (headers['content-type'] === 'text/b64-encoded') {
        let data = response.data;
        data = forge.util.decode64(data);
        if (headers['original-content-type'] === 'application/json') {
            try {
                response['encoded-response'] = data;
                data = JSON.parse(data);
            } catch (ex) {
                response['is-json'] = false;
            }
        }
        response.data = data;
    }

    return response;
};


export default fnResponseSuccess;
